// extracted by mini-css-extract-plugin
export default {"modal":"DLlE6h","description":"Az3P8o","actions":"OT9NGS","button":"EaOL7E"};